import { render } from "./keyBoardHang.vue?vue&type=template&id=3e0cf8c5"
import script from "./keyBoardHang.vue?vue&type=script&lang=js"
export * from "./keyBoardHang.vue?vue&type=script&lang=js"

import "./keyBoardHang.vue?vue&type=style&index=0&id=3e0cf8c5&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__